// Recovered compiled webpack factory 48895. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { q: () => n });
  let n = (t, e, i) => (i > e ? e : i < t ? t : i);
}
